export default __webpack_public_path__ + "static/media/vitallis.36b30264.png";